import { Button, Link, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@material-ui/core";
import { ToggleButton, ToggleButtonGroup } from "@material-ui/lab";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import { Listing, MonoText } from "components";
import PropTypes from "prop-types";
import React from "react";
import { Link as RouterLink } from "react-router-dom";
import capitalise from "utils/capitalise";

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  inner: {
    minWidth: 700
  },
  nameCell: {
    display: "flex",
    alignItems: "center"
  },
  actions: {
    padding: theme.spacing(1),
    justifyContent: "flex-end"
  },
  mono: {
    fontFamily: "Roboto Mono"
  }
}));

const Results = props => {
  const { className, models, filter, loading, onPageChange, title, ...rest } = props;

  const classes = useStyles();

  const handleTypeChange = (type) => {
    onPageChange({ type, offset: 0 });
  }

  return (
    <Listing
      title={title}
      onPageChange={onPageChange}
      loading={loading}
      filter={filter}
      headerAction={<TypeToggle value={filter.type} handleFieldChange={handleTypeChange} />}
      {...rest}
      className={clsx(classes.root, className)}
    >
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell>Email</TableCell>
            <TableCell>Type</TableCell>
            <TableCell align="right">Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {models.map(model => (
            <TableRow hover key={model.id}>
              <TableCell>
                <Link color="inherit" component={RouterLink} to={`/accounts/${model.id}/summary`} variant="h6">
                  {model.displayname}
                </Link>
                <div>
                  <Typography variant="caption"><MonoText>{model.reference}</MonoText></Typography>
                </div>
              </TableCell>
              <TableCell>
                <MonoText>{model.email}</MonoText>
              </TableCell>
              <TableCell>{capitalise(model.type)}</TableCell>
              <TableCell align="right">
                <Button color="primary" component={RouterLink} size="small" to={`/accounts/${model.id}/summary`} variant="outlined">
                  View
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Listing>
  );
};

Results.propTypes = {
  className: PropTypes.string,
  loading: PropTypes.bool,
  onPageChange: PropTypes.func.isRequired,
  filter: PropTypes.object.isRequired,
  models: PropTypes.array.isRequired
};

Results.defaultProps = {
  loading: false,
  onPageChange: () => { },
  models: [],
  filter: {}
};

const TypeToggle = props => {
  const { handleFieldChange, value } = props;

  return (
    <ToggleButtonGroup
      exclusive
      onChange={(event, val) =>
        handleFieldChange(val)
      }
      size="small"
      value={value}
      variant="outlined"
    >
      <ToggleButton
        value="admin"
      >
        Admin
      </ToggleButton>
      <ToggleButton
        value="user"
      >
        User
      </ToggleButton>
      <ToggleButton value="teacher">Teacher</ToggleButton>
    </ToggleButtonGroup>
  )
}

export default Results;